import { ButtonDetailCommissionSignalmanComponent } from '@components/button/tables/commissions-signalman/button-modify-commission-signalman.component';
import { ButtonDeleteCommissionSignalmanComponent } from '@components/button/tables/commissions-signalman/button-delete-commission-signalman.component';

export class CommissionsSignalmanSettings {
  public static gridSettings() {
    return {
      actions: false,
      noDataMessage: 'Nessun dato trovato',
      attr: {
        class: 'table table-bordered',
      },
      pager: {
        display: true,
        perPage: 25,
      },
      columns: {
        detailButton: {
          type: 'custom',
          renderComponent: ButtonDetailCommissionSignalmanComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        deleteButton: {
          type: 'custom',
          renderComponent: ButtonDeleteCommissionSignalmanComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        id: {
          title: 'Id',
          width: '70px',
        },
        anno: {
          title: 'Anno',
        },
        tipoVendita: {
          title: 'Tipo vendita',
          filter: {
            type: 'list',
            config: {
              list: [
                { value: 'PRONTA_CONSEGNA', title: 'PRONTA_CONSEGNA' },
                { value: 'NO_PRONTA_CONSEGNA', title: 'NO_PRONTA_CONSEGNA' },
              ],
            },
          },
        },
        percentualeProvvigione: {
          title: '% Provvigione',
        },
        enabled: {
          title: 'Abilitato',
          valuePrepareFunction: (abilitato) => {
            if (abilitato) {
              return 'Si';
            } else {
              return 'No';
            }
          },
          filter: {
            type: 'list',
            config: {
              list: [
                { value: true, title: 'Si' },
                { value: false, title: 'No' },
              ],
            },
          },
        },
      },
      delete: null,
    };
  }
}
